import React from "react";
import { Theme, ThemeFontVariant, ThemeIntent } from "../types";
import { BemHelper } from "@/utils/BemHelper";
import { THEMES, THEME_FONT_VARIANTS, THEME_INTENTS } from "../constants";
import classNames from "classnames";

export type CtPriceProps = {
  price: number | string;
  currency?: string;
  fontVariant?: ThemeFontVariant;
  intent?: ThemeIntent;
  theme?: Theme;
  size?: "small" | "medium" | "large";
  style?: React.CSSProperties;
  className?: string;
  fontType?: "heading" | "body";
  label?: string;
};

const bem = new BemHelper("ct-price");

function CtPrice({
  price,
  currency,
  fontVariant,
  intent,
  theme,
  size,
  style,
  className,
  fontType,
  label,
}: CtPriceProps) {
  const classes = classNames(
    bem.block(),
    bem.modifier(theme || THEMES.THEME_1),
    bem.modifier(fontVariant || THEME_FONT_VARIANTS.FONT_VARIANT_1),
    bem.modifier(intent || THEME_INTENTS.DEFAULT),
    bem.modifier(size || "medium"),
    bem.modifier(fontType || "heading"),
    className,
  );

  if (isNaN(Number(price)) || price === undefined || price === null) {
    return null;
  }

  if (Number(price) === 0) {
    return (
      <span className={classes} style={style}>
        {label && <span className={classNames(bem.element("label"))}>{label} </span>}
        Free
      </span>
    );
  }

  if (currency) {
    return (
      <span className={classes} style={style}>
        {label && <span className={classNames(bem.element("label"))}>{label} </span>}
        {new Intl.NumberFormat("en-US", {
          style: "currency",
          currency,
        }).format(Number(price))}
      </span>
    );
  }

  return (
    <span className={classes} style={style}>
      {label && <span className={classNames(bem.element("label"))}>{label} </span>}
      {price}
    </span>
  );
}

CtPrice.defaultProps = {
  currency: "USD",
  theme: THEMES.THEME_1,
  fontVariant: THEME_FONT_VARIANTS.FONT_VARIANT_1,
  intent: THEME_INTENTS.DEFAULT,
  size: "medium",
  fontType: "heading",
  label: "",
};

export default CtPrice;
